import { NgModule } from '@angular/core';
import { MakePaymentModule } from './make-payment/make-payment.module';
import { MatDialogModule } from '@angular/material/dialog';
import { WithdrawMoneyModule } from './withdraw-money/withdraw-money.module';
import { RequestMoneyModule } from './request-money/request-money.module';
import { AddMoneyModule } from './add-money/add-money.module';
import { CreditPaymentModule } from './credit-payment/credit-payment.module';
import { DeleteBankAccountModule } from './delete-bank-account/delete-bank-account.component.module';
import { EditBankAccountModule } from './edit-bank-account/edit-bank-account.module';
import { InvoiceFundsModule } from './invoice-funds/invoice-funds.module';
import { ConvertFundsModule } from './convert-funds/convert-funds.module';
import { StudentPaymentsModule } from './student-payment/student-payments.module';
import { DeletePaymentsModule } from './delete-payments/delete-payment.module';
import { DeleteProviderModule } from './delete-provider/delete-provider.module';
import { ActionConfirmationModule } from './action-confirmation/action-confirmation.module';
import { InviteNewUserModule } from './invite-new-user/invite-new-user.module';
import { DeactivateUserModule } from './deactivate-user/deactivate-user.module';
import { EditUserNameModule } from './edit-user-name/edit-user-name.module';
import { RegisterEmailModule } from './register-email/register-email.module';
import { PaymentCustomSpreadModule } from './payment-custom-spread/payment-custom-spread.module';
import { CommissionsModule } from './commissions/commissions.module';

const MODULES = [
  MakePaymentModule,
  WithdrawMoneyModule,
  RequestMoneyModule,
  AddMoneyModule,
  CreditPaymentModule,
  DeleteBankAccountModule,
  DeleteProviderModule,
  EditBankAccountModule,
  InvoiceFundsModule,
  CommissionsModule,
  ConvertFundsModule,
  StudentPaymentsModule,
  DeletePaymentsModule,
  ActionConfirmationModule,
  InviteNewUserModule,
  DeactivateUserModule,
  EditUserNameModule,
  RegisterEmailModule,
  PaymentCustomSpreadModule,
];

@NgModule({
  declarations: [],
  imports: [...MODULES],
  exports: [...MODULES, MatDialogModule],
})
export class MatDialogsModule {}
